/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMemberStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMemberStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMemberStatusByIdIdRegExpTwo)]).optional()
});

export type GetMemberStatusById = zod.input<typeof GetMemberStatusById>;
export type GetMemberStatusByIdOutput = zod.output<typeof GetMemberStatusById>;
